import { WhyChooseList } from "./WhyChooseList";

export { WhyChooseList };
